import { render } from "./resend_activate.vue?vue&type=template&id=27ce0b16"
import script from "./resend_activate.vue?vue&type=script&lang=js"
export * from "./resend_activate.vue?vue&type=script&lang=js"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__